import Services from './Services';

class SportsbookHistoryService extends Services {
  getHistory = async (params, { signal } = {}) =>
    await this.decorate(async () => await this.axios('/sportsbook/history', {
      method: 'GET',
      params,
      signal,
    }));

  getHistoryDetail = async (historyId, { signal } = {}) =>
    await this.decorate(async () => await this.axios(`/sportsbook/history/${encodeURIComponent(historyId)}`, {
      method: 'GET',
      signal,
    }));

  cancelHistory = async (historyId, data, { signal } = {}) =>
    await this.decorate(async () => await this.axios(`/sportsbook/history/${encodeURIComponent(historyId)}/cancel`, {
      method: 'POST',
      data,
      signal,
    }));
}

export default SportsbookHistoryService;
